export const GET_FILE_PATH = "useGetFilePath";
export const GET_PROCESSED_THERMAL_IMAGES = "useGetProcessedThermalImages";
export const GET_LIDAR_DATA_VISUALIZATION_SUMMARIES_FOR_LAST_SPECIFIC_HEATS =
  "useGetLiDARDataVisualizationSummariesForLastSpecificHeats";
export const GET_CAMPAIGN_HEATS_FOR_ASSET = "get-campaign-heats-for-asset";
export const GET_CONVERSATIONS = "get-conversations";
export const GET_REQUESTS = "get-requests";
export const GET_REQUESTS_FOR_HEAT = "get-requests-for-heat";
